/**
 * SeatCard
 * 詳細設計書 §4.2「座席カードの 4 状態」に対応。
 *
 * Props:
 *   seatId       {string}  座席番号（例: "A-05"）
 *   isMine       {boolean} 自分の席かどうか
 *   isOccupied   {boolean} 他者が在席しているか
 *   occupantName {string|null} 在席者の苗字（null = 空席）
 *   isUnavailable {boolean} 使用不可席か（F-* 席）
 *   style        {object}  絶対座標指定用（下段エリアで使用）
 */
function SeatCard({
  seatId,
  isMine = false,
  isOccupied = false,
  occupantName = null,
  isUnavailable = false,
  style = {},
}) {
  let stateClass = 'life-seat-card--empty';
  let label = '';

  if (isUnavailable) {
    stateClass = 'life-seat-card--unavailable';
    label = '使用不可';
  } else if (isMine) {
    stateClass = 'life-seat-card--mine';
    label = '自分';
  } else if (isOccupied && occupantName) {
    stateClass = 'life-seat-card--occupied';
    label = occupantName;
  } else if (isOccupied) {
    stateClass = 'life-seat-card--occupied';
    label = '在席';
  }

  return (
    <div
      className={`life-seat-card ${stateClass}`}
      style={style}
      title={seatId}
      aria-label={`${seatId} ${isUnavailable ? '使用不可' : isMine ? '自分の席' : isOccupied ? `在席: ${occupantName || ''}` : '空席'}`}
    >
      <span className="life-seat-card__id">{seatId}</span>
      {label ? <span className="life-seat-card__label">{label}</span> : null}
    </div>
  );
}

export default SeatCard;
